import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Generic mutation for any organization operation (create, delete, update, etc.)
 *
 * @param mutationFn The mutation function to run (e.g. OrganizationService.createOrganization)
 * @param options Extra options: queryKey for invalidation, onSuccess, onError, etc.
 */
export function useOrganizationMutation<TArg, TResult>(
  mutationFn: (arg: TArg) => Promise<TResult>,
  options?: {
    queryKey?: (string | number)[];
    onSuccess?: () => void;
    onError?: (error: unknown) => void;
    onSettled?: () => void;
  },
) {
  const queryClient = useQueryClient();

  const {
    queryKey = ['organizations'],
    onSuccess,
    onError,
    onSettled,
  } = options || {};

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      onSuccess?.();
    },
    onError,
    onSettled,
  });
}
